<template>
  <div class="cp-ingredient-list ingredients">
    <Title size="m" class="ingredients__title" suptitle="ingrédients"
      >Il vous faut</Title
    >
    <div class="counter">
      <button
        class="counter__button counter__button--minus"
        @click="() => countDown()"
      >
        -
      </button>
      <span class="counter__display">
        <span class="counter__value">{{ counter }}</span>
        <span class="counter__label">{{ counterLabel }}</span>
      </span>
      <button class="counter__button counter__button--plus" @click="countUp()">
        +
      </button>
    </div>
    <ul class="ingredients__items">
      <Ingredient
        v-for="(ingredient, idx) in ingredients"
        :key="'ingredient' + idx"
        :ingredient="ingredient"
        :counter="counter"
        :nbPerson="nbPerson"
      />
    </ul>
  </div>
</template>
<script>
import Title from "@/components/ui/Title.vue";
import Ingredient from "./Ingredient.vue";
export default {
  name: "IngredientList",
  components: {
    Ingredient,
    Title
  },
  props: {
    ingredients: Array,
    nbPerson: Number,
    recipe: Object
  },
  computed: {
    counterLabel: function() {
      if (this.recipe.count_as_unit) {
        if (this.counter > 1) {
          return this.recipe.count_label_plural || "pièces";
        } else {
          return this.recipe.count_label_singular || "pièce";
        }
      } else {
        return this.counter > 1 ? "personnes" : "personne";
      }
    }
  },
  data() {
    return {
      counter: this.nbPerson
    };
  },
  methods: {
    countDown() {
      this.counter--;
      this.$emit("counter", this.counter);
    },
    countUp() {
      this.counter++;
      this.$emit("counter", this.counter);
    }
  }
};
</script>
<style lang="scss" scoped>
.ingredients {
  &__title {
    text-align: center;
  }
  &__items {
    list-style: none;
    padding: 0;
    margin: 20px 0 0;
  }
}
.counter {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  &__display {
    text-align: center;
  }
  &__value,
  &__label {
    display: block;
  }
  &__value {
    font-size: 18px;
    font-weight: 600;
  }
  &__label {
    font-size: 12px;
    font-weight: 300;
    text-transform: uppercase;
    margin-right: 8px;
    margin-left: 8px;
  }
  &__button {
    display: flex;
    width: 1.5em;
    height: 1.5em;
    justify-content: center;
    align-items: center;
    background-color: transparent;
    border: 1px solid $primary;
    border-radius: 100px;
    color: $primary;
    font-size: 18px;
  }
}
</style>
